import { Nudge } from '../../../Types/Nudge';
import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from '../../../hooks';
import Loading from '../../../Components/Loading';
import RenderNudgeItem from './RenderNudgeItem';
import { Container, Row } from 'reactstrap';

const NudgeReport = () => {
    const [ nudges, setNudges ] = useState<Nudge []>([]);
    const [ getError, setGetError ] = useState<any>('');
    const [ loading, setLoading ] = useState<boolean>(false);
    const token = useAppSelector((state) => state.auth.token);
    const currentWriter = useAppSelector((state) => state.writer.salesRepWriterId);

    // useEffect(
    //     useCallback(() => {
    //         getNudges();
    //     }, [token])
    // );

    useEffect(() =>{
        getNudges();
    }, [token]);

    const getNudges = async () => {
        try {
            setLoading(true);
            const baseUrl = 'https://customer.hirsch.com//account/v2/employee/nudge';
            const params = new URLSearchParams();

            if (currentWriter) params.append('writerId', currentWriter);
            
            const res = await fetch(`${baseUrl}?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': btoa(`Bearer ${token}`)
                }
            })

            const json = await res.json();
            console.log('Get Nudge Res:', json);
            setNudges(json.nudges);
            setLoading(false);
        } catch (err: any) {
            setGetError(err);
            console.error('Get Nudge Error:', err);
        }
    };

    return (
        <>
            {loading 
                ? (<Loading />)
                : (
                    <Container>
                        {getError && <span 
                            style={{ 
                                color: 'red', 
                                fontSize: 18,
                                margin: 10,
                            }}>ERROR: {getError}</span>}
                        {nudges?.length <= 0 || nudges == undefined 
                            ?
                            (
                                <Row style={{ alignItems: 'center', marginTop: 20 }}>
                                    <span style={{ fontWeight: 'bold', fontSize: 18 }}>No Open Nudges!</span>
                                </Row>
                            ) : (
                                nudges.map((item) => (
                                    <RenderNudgeItem key={item.crmTransactionId} item={item}/>
                                ))
                            )
                        }
                    </Container>
                )
            }
        </>
    )
};

export default NudgeReport;